module.exports = __webpack_public_path__ + "img/light-mud-decal-29.ee04dccb.png";